module.exports = __webpack_public_path__ + "42e250a56eef201c5644dbce38305bb1.MP3";